import {
  companyPartnerIntegrationsService,
  UpdateCompanyPartnerIntegrationStatusRequest,
} from '@aslanpay/portal-common-lib';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UpdateIntegrationStatusParams {
  id: string;
  companyId: string;
  body: UpdateCompanyPartnerIntegrationStatusRequest;
}

const useUpdateIntegrationStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: UpdateIntegrationStatusParams) =>
      companyPartnerIntegrationsService.updateStatus(id, body),
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['fetchCompanyIntegrations', companyId] });
    },
  });
};

export default useUpdateIntegrationStatus;
